// src/contexts/font-context.tsx
import React, { createContext, useContext, useEffect } from "react";
import { useLocalStorage } from "@/hooks/use-local-storage";
import { loadGoogleFont } from "@/utils/font-loader";

export type Font = {
  name: string;
  value: string;
};

interface FontContextType {
  font: string;
  setFont: (font: string) => void;
  availableFonts: Font[];
}

const FontContext = createContext<FontContextType | undefined>(undefined);

const availableFonts: Font[] = [
  { name: "Oxanium", value: "Oxanium" },
  { name: "Roboto", value: "Roboto" },
  { name: "Poppins", value: "Poppins" },
  { name: "Montserrat", value: "Montserrat" },
  { name: "Caveat", value: "Caveat" },
  { name: "Merriweather", value: "Merriweather" },
];

export const FontProvider = ({ children }: { children: React.ReactNode }) => {
  const [font, setFont] = useLocalStorage<string>("brand-font", "Oxanium");

  useEffect(() => {
    if (font) {
      loadGoogleFont(font);
      document.documentElement.style.setProperty(
        "--font-sans",
        `${font}, sans-serif`,
      );
      document.documentElement.style.setProperty(
        "--font-heading",
        `${font}, sans-serif`,
      );
    }
  }, [font]);

  return (
    <FontContext.Provider value={{ font, setFont, availableFonts }}>
      {children}
    </FontContext.Provider>
  );
};

export const useFont = () => {
  const context = useContext(FontContext);
  if (context === undefined) {
    throw new Error("useFont must be used within a FontProvider");
  }
  return context;
};
